import {createAction} from 'util/redux';

const NAMESPACE = 'NOTI_DRAWER/'
export const notiDrawerOpenAction = createAction<boolean>(NAMESPACE + 'open')